import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Card, CardContent, CardActions, Button, Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, FormControl, InputLabel, Chip } from '@mui/material';
import axios from 'axios';
import Loading from '../components/Loading';
import API_URL from '../config';

function Team() {
  const [team, setTeam] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [assignment, setAssignment] = useState({ project_id: '', role: '' });

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const fetchData = async () => {
    setLoading(true);
    try {
      const [teamRes, projRes] = await Promise.all([
        axios.get(`${API_URL}/team`, { headers }),
        axios.get(`${API_URL}/projects`, { headers })
      ]);
      setTeam(teamRes.data);
      setProjects(projRes.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleAssign = async () => {
    try {
      await axios.post(`${API_URL}/team/assign`, { user_id: selectedUser.id, ...assignment }, { headers });
      setOpen(false);
      fetchData(); // Refresh
    } catch (err) {
      alert('Error assigning project');
    }
  };

  const openAssignDialog = (user) => {
      setSelectedUser(user);
      setOpen(true);
  }

  if (loading) return <Loading message="Loading Team..." />;

  // Group users by Country -> Division
  const groupedTeam = team.reduce((acc, user) => {
    const country = user.country || 'Global';
    const division = user.division || 'General';
    
    if (!acc[country]) acc[country] = {};
    if (!acc[country][division]) acc[country][division] = [];
    
    acc[country][division].push(user);
    return acc;
  }, {});

  return (
    <Box>
   
      
      {Object.entries(groupedTeam).map(([country, divisions]) => (
        <Box key={country} sx={{ mb: 5 }}>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold', color: 'primary.main', borderBottom: '2px solid', borderColor: 'primary.light', pb: 1 }}>
                {country}
            </Typography>
            
            {Object.entries(divisions).map(([division, users]) => (
                <Box key={division} sx={{ mb: 4, ml: { xs: 0, md: 3 } }}>
                    <Typography variant="h6" sx={{ mb: 2, color: 'text.secondary', display: 'flex', alignItems: 'center' }}>
                        <Box component="span" sx={{ width: 8, height: 8, bgcolor: 'secondary.main', borderRadius: '50%', mr: 1, display: 'inline-block' }} />
                        {division} Division
                    </Typography>
                    
                    <Grid container spacing={3}>
                        {users.map(user => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={user.id}>
                            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: 2, boxShadow: 2 }}>
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Typography variant="h6" gutterBottom>{user.name}</Typography>
                                <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>
                                    {user.role}
                                </Typography>
                                
                                <Box sx={{ bgcolor: 'action.hover', p: 1, borderRadius: 1 }}>
                                    <Typography variant="caption" display="block" color="textSecondary" sx={{ mb: 0.5 }}>Current Projects</Typography>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {user.current_projects && user.current_projects.length > 0 ? (
                                            user.current_projects.map((proj, idx) => (
                                                <Chip key={idx} label={proj} size="small" color="primary" variant="outlined" sx={{ fontSize: '0.7rem' }} />
                                            ))
                                        ) : (
                                            <Typography variant="body2" color="textSecondary">None</Typography>
                                        )}
                                    </Box>
                                </Box>
                            </CardContent>
                            <CardActions sx={{ p: 2, pt: 0 }}>
                                <Button size="small" variant="contained" fullWidth onClick={() => openAssignDialog(user)}>Assign Project</Button>
                            </CardActions>
                            </Card>
                        </Grid>
                        ))}
                    </Grid>
                </Box>
            ))}
        </Box>
      ))}

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Assign Project to {selectedUser?.name}</DialogTitle>
        <DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1, minWidth: 300 }}>
                <FormControl fullWidth>
                    <InputLabel>Project</InputLabel>
                    <Select value={assignment.project_id} label="Project" onChange={e => setAssignment({...assignment, project_id: e.target.value})}>
                        {projects.map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}
                    </Select>
                </FormControl>
                <FormControl fullWidth>
                    <InputLabel>Role</InputLabel>
                    <Select value={assignment.role} label="Role" onChange={e => setAssignment({...assignment, role: e.target.value})}>
                        <MenuItem value="Lead">Lead</MenuItem>
                        <MenuItem value="Member">Member</MenuItem>
                        <MenuItem value="Reviewer">Reviewer</MenuItem>
                    </Select>
                </FormControl>
            </Box>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={handleAssign} variant="contained">Assign</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Team;
